import { render, staticRenderFns } from "./ProjectMerge.vue?vue&type=template&id=4267dcf1&scoped=true&"
import script from "./ProjectMerge.vue?vue&type=script&lang=js&"
export * from "./ProjectMerge.vue?vue&type=script&lang=js&"
import style0 from "./ProjectMerge.vue?vue&type=style&index=0&id=4267dcf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4267dcf1",
  null
  
)

export default component.exports